import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import VueAuth from '@websanova/vue-auth'
import Vuelidate from 'vuelidate'
import VueShortcuts from 'vue-shortcuts'
import VDocViewer from 'v-doc-viewer'
import Pusher from 'pusher-js'
import vueDebounce from 'vue-debounce'
import store from './store'
import './registerServiceWorker'
import './lang'
import './axios'
import './style'
import './progress'
import './filters'
import '@/utils/consoleLogs'
import router from './router'
import App from './App.vue'
import infiniteScroll from 'vue-infinite-scroll'
import ToggleButton from 'vue-js-toggle-button'

Vue.config.productionTip = false
window.Pusher = Pusher

Vue.use(ToggleButton)
Vue.use(vueDebounce)
Vue.use(VueApexCharts)
Vue.use(infiniteScroll)
Vue.use(VDocViewer)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueShortcuts, { prevent: ['input', 'textarea'] })
Vue.use(Vuelidate)
Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'view_roles',
  parseUserData: user => user
})

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
